import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Checkbox, Divider, Form, Grid, Icon, Image, Input, Popup, Tab } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import ImageUpload from "~/components/element/ImageUpload/ImageUpload";
import Provider from "~/models/Provider";
import Customer from "~/models/Customer";
import UiMeet3dPhotoStore from "~/stores/UiMeet3d/UiMeet3dPhotoStore";
import UiMeet3dPhotoType from "~/constants/UiMeet3d/UiMeet3dPhotoType";

@observer
class GreetingBotGeneralForm extends Component {
  render() {
    const {
      t,
      model,
      bindInput,
      setProperty,
      validation,
      uiMeet3dPhotoModel,
      uiMeet3dPhotoSetProperty,
      actualUser,
      uiMeet3dGreetingBotDefaultValues,
      getUiMeet3dGreetingBotDefaultValueCallback,
      uiMeet3dPhotoStore,
    } = this.props;
    const { uiMeet3dPhotos } = uiMeet3dPhotoStore;

    const greetingBotAvatarPhotoPathWeb = uiMeet3dPhotoStore.getUiMeet3dPhotoPathWeb(
      uiMeet3dPhotos,
      UiMeet3dPhotoType.GREETING_BOT_AVATAR,
    );
    const canDeleteGreetingBotAvatarPhoto = uiMeet3dPhotoStore.canDeleteUiMeet3dPhoto(
      uiMeet3dPhotos,
      UiMeet3dPhotoType.GREETING_BOT_AVATAR,
    );

    const finalGreetingBotAvatarPhotoPathWeb =
      greetingBotAvatarPhotoPathWeb ||
      (typeof actualUser.photoUrl !== "undefined" && actualUser.photoUrl !== null && actualUser.photoPathWeb) ||
      "/tourbuilder/assets/images/user_sil.jpg";

    return (
      <Form className="greeting-bot-form-wrap general-info">
        <h2>{t("general")}</h2>
        <Form.Field
          control={Checkbox}
          label={t("clientPanelMisc:greetingBotEnabled")}
          checked={model.enabled}
          onChange={() => setProperty("enabled", !model.enabled)}
        />
        <Form.Field
          control={Input}
          label={t("name")}
          {...bindInput("name", validation)}
          value={model.name}
          placeholder={t("greetingBotDefaultValues:name")}
        />
        <p>
          <i>{t("clientPanelMisc:greetingBotNameDescription")}</i>{" "}
          <Popup
            content={
              <Image
                src="https://www.urbanimmersive.com/images/pages/uimeet3d/uimeet3d_features_bot_profile_settings.jpg"
                size="massive"
              />
            }
            trigger={<Icon name="question circle outline" />}
          />
        </p>
        <Grid columns="equal">
          <Grid.Column>
            <div className="image-upload">
              <h4>{t("clientPanelMisc:avatar")}</h4>
              <Checkbox
                disabled={!canDeleteGreetingBotAvatarPhoto}
                label={t("clientPanelInfo:clickDelete")}
                checked={canDeleteGreetingBotAvatarPhoto && uiMeet3dPhotoModel.deleteGreetingBotAvatarPhoto}
                onChange={() =>
                  uiMeet3dPhotoSetProperty(
                    "deleteGreetingBotAvatarPhoto",
                    !uiMeet3dPhotoModel.deleteGreetingBotAvatarPhoto,
                  )
                }
              />
              <ImageUpload
                onFileSelected={encoded => uiMeet3dPhotoSetProperty("greetingBotAvatarPhotoData", encoded)}
                defaultSrc={finalGreetingBotAvatarPhotoPathWeb}
                accept={["image/jpeg"]}
              />
            </div>
          </Grid.Column>
          <Grid.Column />
        </Grid>
        <Divider />
        <h4>{t("clientPanelMisc:greetingMessage")}</h4>
        <Tab
          panes={[
            {
              menuItem: t("english"),
              render: () => (
                <Tab.Pane>
                  <Form.Group widths="equal">
                    <Form.Input
                      fluid
                      label={t("clientPanelMisc:callToAction")}
                      {...bindInput("message_enQuestion")}
                      value={model.message_enQuestion}
                      placeholder={getUiMeet3dGreetingBotDefaultValueCallback(
                        uiMeet3dGreetingBotDefaultValues,
                        "messageQuestion",
                        "en",
                      )}
                    />
                    <Form.Input
                      fluid
                      label={t("clientPanelMisc:okLabel")}
                      {...bindInput("message_enAnswerYes")}
                      value={model.message_enAnswerYes}
                      placeholder={getUiMeet3dGreetingBotDefaultValueCallback(
                        uiMeet3dGreetingBotDefaultValues,
                        "messageAnswerYes",
                        "en",
                      )}
                    />
                    <Form.Input
                      fluid
                      label={t("clientPanelMisc:cancelLabel")}
                      {...bindInput("message_enAnswerNo")}
                      value={model.message_enAnswerNo}
                      placeholder={getUiMeet3dGreetingBotDefaultValueCallback(
                        uiMeet3dGreetingBotDefaultValues,
                        "messageAnswerNo",
                        "en",
                      )}
                    />
                  </Form.Group>
                </Tab.Pane>
              ),
            },
            {
              menuItem: t("french"),
              render: () => (
                <Tab.Pane>
                  <Form.Group widths="equal">
                    <Form.Input
                      fluid
                      label={t("clientPanelMisc:callToAction")}
                      {...bindInput("message_frQuestion")}
                      value={model.message_frQuestion}
                      placeholder={getUiMeet3dGreetingBotDefaultValueCallback(
                        uiMeet3dGreetingBotDefaultValues,
                        "messageQuestion",
                        "fr",
                      )}
                    />
                    <Form.Input
                      fluid
                      label={t("clientPanelMisc:okLabel")}
                      {...bindInput("message_frAnswerYes")}
                      value={model.message_frAnswerYes}
                      placeholder={getUiMeet3dGreetingBotDefaultValueCallback(
                        uiMeet3dGreetingBotDefaultValues,
                        "messageAnswerYes",
                        "fr",
                      )}
                    />
                    <Form.Input
                      fluid
                      label={t("clientPanelMisc:cancelLabel")}
                      {...bindInput("message_frAnswerNo")}
                      value={model.message_frAnswerNo}
                      placeholder={getUiMeet3dGreetingBotDefaultValueCallback(
                        uiMeet3dGreetingBotDefaultValues,
                        "messageAnswerNo",
                        "fr",
                      )}
                    />
                  </Form.Group>
                </Tab.Pane>
              ),
            },
          ]}
        />
        <h4>{t("clientPanelMisc:dismissMessage")}</h4>
        <Tab
          panes={[
            {
              menuItem: t("english"),
              render: () => (
                <Tab.Pane>
                  <Form.Input
                    fluid
                    label={t("clientPanelMisc:messageText")}
                    {...bindInput("dismiss_en")}
                    value={model.dismiss_en}
                    placeholder={getUiMeet3dGreetingBotDefaultValueCallback(
                      uiMeet3dGreetingBotDefaultValues,
                      "dismiss",
                      "en",
                    )}
                  />
                </Tab.Pane>
              ),
            },
            {
              menuItem: t("french"),
              render: () => (
                <Tab.Pane>
                  <Form.Input
                    fluid
                    label={t("clientPanelMisc:messageText")}
                    {...bindInput("dismiss_fr")}
                    value={model.dismiss_fr}
                    placeholder={getUiMeet3dGreetingBotDefaultValueCallback(
                      uiMeet3dGreetingBotDefaultValues,
                      "dismiss",
                      "fr",
                    )}
                  />
                </Tab.Pane>
              ),
            },
          ]}
        />
      </Form>
    );
  }
}

GreetingBotGeneralForm.propTypes = {
  t: PropTypes.func.isRequired,
  actualUser: PropTypes.oneOfType([PropTypes.instanceOf(Provider), PropTypes.instanceOf(Customer)]),
  model: PropTypes.shape({
    enabled: PropTypes.bool,
    name: PropTypes.string,
    message_enQuestion: PropTypes.string,
    message_enAnswerYes: PropTypes.string,
    message_enAnswerNo: PropTypes.string,
    message_frQuestion: PropTypes.string,
    message_frAnswerYes: PropTypes.string,
    message_frAnswerNo: PropTypes.string,
    dismiss_en: PropTypes.string,
    dismiss_fr: PropTypes.string,
  }).isRequired,
  uiMeet3dPhotoModel: PropTypes.shape({
    greetingBotPhotoData: PropTypes.string,
    deleteGreetingBotAvatarPhoto: PropTypes.bool,
  }).isRequired,
  setProperty: PropTypes.func.isRequired,
  bindInput: PropTypes.func.isRequired,
  uiMeet3dPhotoSetProperty: PropTypes.func.isRequired,
  validation: PropTypes.shape({
    isValid: PropTypes.bool,
    // keys maps the model keys and the value is an object of shape { isValid: <bool>, errors: <Array> }
    fields: PropTypes.object,
  }).isRequired,
  uiMeet3dGreetingBotDefaultValues: PropTypes.array.isRequired,
  getUiMeet3dGreetingBotDefaultValueCallback: PropTypes.func.isRequired,
  uiMeet3dPhotoStore: PropTypes.instanceOf(UiMeet3dPhotoStore),
};

export default withTranslation()(GreetingBotGeneralForm);
